import React from 'react'
import { Helmet } from 'react-helmet'
import config from './config'
import _ from 'lodash'
import connect from './tools/connect'
import initializeSkin from './tools/skinAd/index'
import updateUtm from './tools/analytics/utm'
import pageStore from './redux/page/store'
import PopupView from './views/Popup'
import Share from './views/Share'
import ErrorPage from './views/ErrorPage'
import ErrorBoundary from './components/ErrorBoundary'
import CookieConsent from '~/components/CookieConsent'
import AppStoreSuggestion from '~/components/AppStoreSuggestion'
import { trackEvent } from '~/tools/analytics/cleverTap'
import lazyLoad from './tools/lazy-load-images'
import NavFocusSkipper from '~/components/NavFocusSkipper'
import './App.css'

import NeoProfile from "~/modules/ViewNeoProfile";
import AllAchievements from "~/modules/Achievements";

class App extends React.Component {
  constructor() {
    super()
    this.showCookieConsent = this.shouldShowCookieConsent()
  }

  // TEMPORARY: whether we show the cookie consent or not should depend on an AppCMS setting
  shouldShowCookieConsent() {
    return !window.settings.internalName.includes('hoichoi')
  }

  componentDidMount() {
    updateUtm()
    initializeSkin(_.get(this.state,'page.data.id'))
    setTimeout(lazyLoad, 2000)
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad)
  }

  triggerPageViewd(pageTitle){
    var { title } = this.state.page.data || {}
    if(title){
      var lastActivity = null
      if(document.referrer && document.referrer !== window.location.href){
        lastActivity = document.referrer
      }
      switch(title){
        case "Video Page":
          pageTitle = title + '-' + pageTitle.split('|')[0]
        break;
        case "Show Page":
          pageTitle = title + '-' + pageTitle.split('|')[0]
        break;
        default:
          pageTitle = title
      }
      trackEvent('Page Viewed', {
        pageName: pageTitle,
        pageURL: window.location.href,
        lastActivityName: lastActivity,
        platform: 'Web'
      })      
    }
  }

  render() {
    var { title, layouts, modules, route } = this.state.page.data || {}
    var classes = ['app', 'appcms', window.SERVER_SIDE_RENDERING ? 'server-side-rendering' : '']
    const page = path => _.get(this.state.page.data, path)
    return (
      <div className={classes.join(' ')}>
        <NavFocusSkipper/>
      
        <Helmet
          onChangeClientState={(newState) => this.triggerPageViewd(newState.title)}>
          <title>
            {page('metadataMap.title') ? page('metadataMap.title') : `${title} | ${window.settings.site}`}
          </title>
          <meta name="description" content={page('metadataMap.description')} />
          <meta name="keywords" content={page('metadataMap.keywords')}/>          
          <meta property="og:type" content="website" />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:title" content={page('metadataMap.title') ? page('metadataMap.title') : title} />
          <meta property="og:description" content={page('metadataMap.description')} />
          <meta property="og:site_name" content={window.settings.site} />
          <meta property="og:image" content={_.get(window.settings, 'images.desktopLogo')} />
          <link rel="alternate" href={window.location.href} hreflang={page('lang') || 'en'} />
          <link rel="icon" type="image/png" sizes="16x16" href={_.get(window.settings, 'images.favicon.16')} />
          <link rel="icon" type="image/png" sizes="32x32" href={_.get(window.settings, 'images.favicon.32')} />
          <link rel="shortcut icon" href={_.get(window.settings, 'images.favicon.ico')} />
          <link rel="canonical" href={'https://' + window.settings.domainName + route } />
        </Helmet>
        {window.settings.skinAdTag && <div id="viewlift-site-skin"></div>}

        <div role="main" className={`modules `+ (window.settings.skinAdTag && 'skin-ad') }> 
          { this.loaded && window.settings.features.app_download_suggestion && 
            <AppStoreSuggestion />
          }
          { 
            this.loaded && 
            this.renderModules(layouts, modules)
          } 
        </div>
        { this.showCookieConsent &&
          <CookieConsent />
        }
        {this.errored && <ErrorPage error={this.state.page.error} />}
        {this.loaded && <PopupView />}
        {this.loaded && <Share />}

      </div>
    )
  }

  get errored() {
    return this.state.page.error != null && !this.state.page.data
  }

  get loaded() {
    return this.state.page.data && !this.state.page.error
  }

  renderModules(layouts, modules) {
    return _.map(layouts, moduleLayout => {
      const { id, view } = moduleLayout
      const moduleData = _.find(modules, { id: id })
      if(!config.mmap[view])
      {
        return console.log(`Module not found for '${view}' id '${id}'`)
      }
      const Module = config.mmap[view].default;
      return (
        <ErrorBoundary key={id}>
          <div className={`module` + (moduleData && moduleData.metadataMap !== null && moduleData.metadataMap && moduleData.metadataMap.align ? ` ${moduleData.metadataMap.align}` : '')}>
            <Module data={moduleData} layout={moduleLayout} />
          </div> 
        </ErrorBoundary>
      )
    })
  }
}

connect(App, state => ({ page: state }), pageStore)

export default App;